
    <div class="container ">


    <div class="splash">
        <div class="inside"><img src="https://www.stg.ma/site2/images/logo.png" alt="">
            <p>Bienvenue à</p>
            <h1>STG DRIVE</h1>
            <div class="bar"></div>
        </div>
    </div>

 
    <div class="login"><img src="https://www.stg.ma/site2/images/logo.png" alt="">
        <h1>Bienvenue à nouveau</h1>
        <p>Réinitialiser le mot de passe</p>
        <form  class="pt-4" matInput  [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
         
            <ngx-spinner bdColor = "rgba(100,112,124,0.56)" size = "medium" color = "#233547" type = "ball-clip-rotate-multiple" [fullScreen] = "true"><p style="color: white" >  </p></ngx-spinner>

                <label>Mot de passe
                </label>
                <input matInput type="password" id="password"  placeholder="****" formControlName="password"  class="inputModal" [errorStateMatcher]="matcher" required>
                <mat-error *ngIf="resetPasswordForm.get('passwordConfirm').hasError('confirmedValidator')" class="elhoo_compte_messageErrorPositionModal">
                    le mot de passe est <strong>obligatoire</strong>
              </mat-error>
        

                <label>Confirmation du mot de passe</label>
                <input  formControlName="passwordConfirm"  placeholder="****"  class="inputModal" id="passwordConfirm" [errorStateMatcher]="matcher" type="password" matInput  required>

              <mat-error *ngIf="resetPasswordForm.get('passwordConfirm').hasError('confirmedValidator')" class="error-txt">Les mots de passe  doivent être identiques.</mat-error>
    

            
              <div *ngIf="showerror ==500" class="alert alert-danger mt-3 mb-0" aria-label="Close">{{messageErrorReset}}</div>
              <div *ngIf="showerror == 200" class="alert alert-success mt-3 mb-0" aria-label="Close">{{messageSuccessReset}}</div>
            <button class="mt-4" [disabled]="loading"  [ngClass]="{'disabled': !resetPasswordForm.valid }">Réinitialiser le mot de passe
            </button>
             <a style="color :var(--dark_color);text-decoration:none" href="/login" class=" mt-2 d-flex justify-content-center "><mat-icon>keyboard_return</mat-icon> Annuler 	 </a>
       
     
            </form>
   
    </div>

</div>


